import React from 'react';
import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';
import { useLocalizedPath } from './hooks';

type Props = Omit<LinkProps, 'to'> & { to: string };

const LocalizedLink: React.FC<Props> = ({ to, ...rest }) => {
  const localize = useLocalizedPath();
  return <Link to={localize(to)} {...rest} />;
};

export default LocalizedLink;
